interface IVoucherPayment {
  totalCost: number;
  details: VoucherDetails[];
  paymentType: string;
  cardNumber: string;
  expirationDate: string;
  cardCode: string;
  email: string;
  firstName: string;
  lastName: string;
  companyName: string;
  address: string;
  city: string;
  state: string;
  zip: string;
  recaptcha: string;
  schoolId: number;
}

export class VoucherPayment implements IVoucherPayment {
  totalCost = null;
  details = null;
  paymentType = null;
  cardNumber = null;
  expirationDate = null;
  cardCode = null;
  email = null;
  firstName = null;
  lastName = null;
  companyName = null;
  address = null;
  city = null;
  state = null;
  zip = null;
  recaptcha = null;
  schoolId = null;
  dataDescriptor = null;
  dataValue = null;
}

export class VoucherDetails {
  examId: number;
  quantity: number;
  cost: number;
}
